// Halftone slash-dot positions for the hero journey cascade animation.

export type HeroJourneyCascadeGlyph = readonly [number, number, 0 | 1, number];

export const HERO_JOURNEY_CASCADE_GLYPHS: readonly HeroJourneyCascadeGlyph[] = [
  [646.0, 0.0, 0, 0.28],
  [1564.0, 0.0, 0, 0.375],
  [136.0, 34.0, 0, 0.374],
  [170.0, 34.0, 0, 0.377],
  [306.0, 34.0, 0, 0.378],
  [680.0, 34.0, 1, 0.38],
  [714.0, 34.0, 1, 0.389],
  [748.0, 34.0, 1, 0.369],
  [1020.0, 34.0, 0, 0.258],
  [1088.0, 34.0, 1, 0.257],
  [1156.0, 34.0, 0, 0.25],
  [1292.0, 34.0, 0, 0.231],
  [1598.0, 34.0, 1, 0.283],
  [102.0, 68.0, 0, 0.323],
  [136.0, 68.0, 0, 0.323],
  [170.0, 68.0, 0, 0.326],
  [204.0, 68.0, 0, 0.329],
  [238.0, 68.0, 0, 0.33],
  [272.0, 68.0, 1, 0.328],
  [306.0, 68.0, 1, 0.32],
  [374.0, 68.0, 0, 0.289],
  [408.0, 68.0, 0, 0.268],
  [510.0, 68.0, 0, 0.242],
  [544.0, 68.0, 0, 0.261],
  [578.0, 68.0, 1, 0.303],
  [612.0, 68.0, 0, 0.354],
  [646.0, 68.0, 1, 0.391],
  [680.0, 68.0, 1, 0.393],
  [714.0, 68.0, 0, 0.364],
  [748.0, 68.0, 0, 0.319],
  [782.0, 68.0, 1, 0.278],
  [816.0, 68.0, 0, 0.252],
  [952.0, 68.0, 1, 0.25],
  [986.0, 68.0, 0, 0.254],
  [1088.0, 68.0, 0, 0.255],
  [1122.0, 68.0, 0, 0.253],
  [1190.0, 68.0, 1, 0.246],
  [1224.0, 68.0, 1, 0.244],
  [1258.0, 68.0, 0, 0.248],
  [1292.0, 68.0, 1, 0.259],
  [1428.0, 68.0, 0, 0.391],
  [1462.0, 68.0, 0, 0.398],
  [1530.0, 68.0, 1, 0.322],
  [1564.0, 68.0, 0, 0.275],
  [1768.0, 68.0, 0, 0.334],
  [1904.0, 68.0, 1, 0.375],
  [102.0, 102.0, 1, 0.268],
  [136.0, 102.0, 1, 0.27],
  [170.0, 102.0, 1, 0.273],
  [204.0, 102.0, 0, 0.277],
  [238.0, 102.0, 0, 0.278],
  [272.0, 102.0, 1, 0.277],
  [306.0, 102.0, 0, 0.272],
  [340.0, 102.0, 0, 0.265],
  [374.0, 102.0, 0, 0.256],
  [442.0, 102.0, 0, 0.246],
  [476.0, 102.0, 0, 0.251],
  [510.0, 102.0, 1, 0.275],
  [544.0, 102.0, 1, 0.319],
  [578.0, 102.0, 1, 0.369],
  [612.0, 102.0, 1, 0.402],
  [646.0, 102.0, 0, 0.399],
  [680.0, 102.0, 0, 0.36],
  [714.0, 102.0, 1, 0.307],
  [748.0, 102.0, 0, 0.262],
  [782.0, 102.0, 1, 0.238],
  [850.0, 102.0, 0, 0.238],
  [918.0, 102.0, 0, 0.258],
  [986.0, 102.0, 1, 0.276],
  [1020.0, 102.0, 0, 0.28],
  [1054.0, 102.0, 0, 0.282],
  [1088.0, 102.0, 0, 0.281],
  [1122.0, 102.0, 0, 0.279],
  [1156.0, 102.0, 0, 0.278],
  [1224.0, 102.0, 0, 0.285],
  [1258.0, 102.0, 0, 0.298],
  [1326.0, 102.0, 0, 0.35],
  [1360.0, 102.0, 0, 0.382],
  [1428.0, 102.0, 1, 0.4],
  [1496.0, 102.0, 1, 0.316],
  [1530.0, 102.0, 1, 0.268],
  [1564.0, 102.0, 0, 0.245],
  [1598.0, 102.0, 0, 0.246],
  [1632.0, 102.0, 0, 0.262],
  [1666.0, 102.0, 0, 0.296],
  [1734.0, 102.0, 0, 0.375],
  [1870.0, 102.0, 0, 0.421],
  [1904.0, 102.0, 1, 0.417],
  [102.0, 136.0, 0, 0.238],
  [136.0, 136.0, 0, 0.242],
  [170.0, 136.0, 0, 0.247],
  [204.0, 136.0, 0, 0.252],
  [238.0, 136.0, 0, 0.255],
  [272.0, 136.0, 0, 0.256],
  [306.0, 136.0, 1, 0.255],
  [340.0, 136.0, 0, 0.254],
  [374.0, 136.0, 0, 0.252],
  [408.0, 136.0, 1, 0.255],
  [442.0, 136.0, 1, 0.268],
  [476.0, 136.0, 1, 0.296],
  [510.0, 136.0, 1, 0.34],
  [544.0, 136.0, 1, 0.387],
  [578.0, 136.0, 0, 0.414],
  [612.0, 136.0, 0, 0.404],
  [646.0, 136.0, 0, 0.359],
  [680.0, 136.0, 0, 0.299],
  [714.0, 136.0, 0, 0.251],
  [748.0, 136.0, 1, 0.23],
  [816.0, 136.0, 0, 0.241],
  [850.0, 136.0, 0, 0.26],
  [884.0, 136.0, 0, 0.284],
  [918.0, 136.0, 0, 0.306],
  [952.0, 136.0, 1, 0.324],
  [986.0, 136.0, 0, 0.335],
  [1020.0, 136.0, 1, 0.341],
  [1054.0, 136.0, 0, 0.343],
  [1088.0, 136.0, 0, 0.342],
  [1122.0, 136.0, 1, 0.34],
  [1156.0, 136.0, 0, 0.341],
  [1190.0, 136.0, 0, 0.344],
  [1224.0, 136.0, 1, 0.354],
  [1258.0, 136.0, 1, 0.369],
  [1292.0, 136.0, 0, 0.388],
  [1326.0, 136.0, 1, 0.406],
  [1360.0, 136.0, 0, 0.413],
  [1394.0, 136.0, 0, 0.4],
  [1428.0, 136.0, 0, 0.362],
  [1462.0, 136.0, 0, 0.309],
  [1496.0, 136.0, 0, 0.262],
  [1530.0, 136.0, 0, 0.242],
  [1564.0, 136.0, 0, 0.245],
  [1598.0, 136.0, 1, 0.268],
  [1632.0, 136.0, 0, 0.313],
  [1666.0, 136.0, 0, 0.367],
  [1768.0, 136.0, 0, 0.445],
  [1802.0, 136.0, 0, 0.442],
  [136.0, 170.0, 0, 0.245],
  [170.0, 170.0, 0, 0.25],
  [204.0, 170.0, 0, 0.255],
  [238.0, 170.0, 0, 0.258],
  [272.0, 170.0, 0, 0.261],
  [306.0, 170.0, 0, 0.263],
  [340.0, 170.0, 1, 0.268],
  [374.0, 170.0, 0, 0.278],
  [408.0, 170.0, 0, 0.297],
  [442.0, 170.0, 0, 0.328],
  [510.0, 170.0, 1, 0.408],
  [544.0, 170.0, 1, 0.427],
  [578.0, 170.0, 0, 0.41],
  [612.0, 170.0, 0, 0.358],
  [646.0, 170.0, 0, 0.293],
  [680.0, 170.0, 0, 0.244],
  [714.0, 170.0, 0, 0.226],
  [748.0, 170.0, 0, 0.23],
  [782.0, 170.0, 0, 0.249],
  [816.0, 170.0, 1, 0.282],
  [850.0, 170.0, 0, 0.321],
  [884.0, 170.0, 1, 0.357],
  [918.0, 170.0, 0, 0.384],
  [952.0, 170.0, 0, 0.402],
  [986.0, 170.0, 1, 0.412],
  [1020.0, 170.0, 0, 0.416],
  [1054.0, 170.0, 0, 0.416],
  [1088.0, 170.0, 0, 0.414],
  [1122.0, 170.0, 0, 0.412],
  [1156.0, 170.0, 0, 0.41],
  [1190.0, 170.0, 1, 0.412],
  [1224.0, 170.0, 0, 0.416],
  [1258.0, 170.0, 0, 0.421],
  [1292.0, 170.0, 0, 0.424],
  [1326.0, 170.0, 1, 0.416],
  [1360.0, 170.0, 1, 0.392],
  [1394.0, 170.0, 0, 0.35],
  [1428.0, 170.0, 1, 0.298],
  [1462.0, 170.0, 1, 0.255],
  [1496.0, 170.0, 1, 0.239],
  [1530.0, 170.0, 1, 0.245],
  [1564.0, 170.0, 0, 0.274],
  [1598.0, 170.0, 0, 0.329],
  [1632.0, 170.0, 1, 0.391],
  [1666.0, 170.0, 0, 0.438],
  [1733.9, 170.0, 0, 0.455],
  [1768.0, 170.0, 0, 0.437],
  [1802.0, 170.0, 0, 0.414],
  [1836.0, 170.0, 1, 0.392],
  [1904.0, 170.0, 0, 0.361],
  [102.0, 204.0, 0, 0.27],
  [136.0, 204.0, 1, 0.279],
  [170.0, 204.0, 0, 0.286],
  [204.0, 204.0, 0, 0.291],
  [238.0, 204.0, 0, 0.296],
  [272.0, 204.0, 0, 0.302],
  [306.0, 204.0, 0, 0.31],
  [340.0, 204.0, 0, 0.323],
  [374.0, 204.0, 1, 0.344],
  [408.0, 204.0, 0, 0.372],
  [442.0, 204.0, 0, 0.405],
  [476.0, 204.0, 1, 0.433],
  [510.0, 204.0, 0, 0.439],
  [544.0, 204.0, 0, 0.413],
  [578.0, 204.0, 0, 0.356],
  [612.0, 204.0, 1, 0.288],
  [646.0, 204.0, 1, 0.239],
  [680.0, 204.0, 1, 0.223],
  [714.0, 204.0, 0, 0.23],
  [748.0, 204.0, 1, 0.26],
  [782.0, 204.0, 1, 0.309],
  [816.0, 204.0, 0, 0.361],
  [850.0, 204.0, 0, 0.406],
  [884.0, 204.0, 0, 0.437],
  [917.8, 204.0, 0, 0.455],
  [951.7, 204.0, 0, 0.464],
  [985.7, 204.0, 0, 0.467],
  [1019.7, 204.0, 0, 0.466],
  [1053.8, 204.0, 0, 0.463],
  [1087.8, 204.0, 0, 0.458],
  [1121.9, 204.0, 0, 0.453],
  [1155.9, 204.0, 0, 0.447],
  [1190.0, 204.0, 0, 0.442],
  [1224.0, 204.0, 0, 0.435],
  [1258.0, 204.0, 1, 0.424],
  [1292.0, 204.0, 0, 0.405],
  [1326.0, 204.0, 0, 0.373],
  [1360.0, 204.0, 1, 0.33],
  [1394.0, 204.0, 0, 0.283],
  [1428.0, 204.0, 0, 0.247],
  [1462.0, 204.0, 0, 0.236],
  [1496.0, 204.0, 0, 0.244],
  [1530.0, 204.0, 0, 0.28],
  [1564.0, 204.0, 0, 0.344],
  [1598.0, 204.0, 0, 0.413],
  [1631.8, 204.0, 1, 0.46],
  [1665.7, 204.0, 0, 0.471],
  [1699.9, 204.0, 1, 0.452],
  [1734.0, 204.0, 0, 0.417],
  [1768.0, 204.0, 1, 0.379],
  [1836.0, 204.0, 0, 0.319],
  [136.0, 238.0, 1, 0.356],
  [170.0, 238.0, 1, 0.363],
  [204.0, 238.0, 1, 0.369],
  [238.0, 238.0, 0, 0.374],
  [272.0, 238.0, 0, 0.381],
  [306.0, 238.0, 0, 0.391],
  [340.0, 238.0, 0, 0.406],
  [374.0, 238.0, 0, 0.425],
  [408.0, 238.0, 0, 0.444],
  [441.8, 238.0, 0, 0.456],
  [475.9, 238.0, 0, 0.448],
  [510.0, 238.0, 0, 0.412],
  [544.0, 238.0, 0, 0.35],
  [578.0, 238.0, 0, 0.282],
  [612.0, 238.0, 0, 0.234],
  [646.0, 238.0, 0, 0.221],
  [680.0, 238.0, 0, 0.232],
  [714.0, 238.0, 0, 0.272],
  [748.0, 238.0, 1, 0.334],
  [782.0, 238.0, 0, 0.398],
  [816.0, 238.0, 0, 0.446],
  [849.6, 238.0, 0, 0.473],
  [883.5, 238.0, 0, 0.482],
  [917.5, 238.0, 0, 0.481],
  [951.6, 238.0, 0, 0.475],
  [985.7, 238.0, 0, 0.467],
  [1019.8, 238.0, 1, 0.459],
  [1053.9, 238.0, 1, 0.451],
  [1088.0, 238.0, 0, 0.444],
  [1122.0, 238.0, 0, 0.436],
  [1156.0, 238.0, 0, 0.426],
  [1190.0, 238.0, 0, 0.413],
  [1224.0, 238.0, 0, 0.396],
  [1258.0, 238.0, 0, 0.372],
  [1292.0, 238.0, 0, 0.34],
  [1326.0, 238.0, 0, 0.302],
  [1360.0, 238.0, 0, 0.264],
  [1394.0, 238.0, 1, 0.238],
  [1428.0, 238.0, 0, 0.233],
  [1462.0, 238.0, 0, 0.245],
  [1496.0, 238.0, 1, 0.287],
  [1530.0, 238.0, 1, 0.357],
  [1564.0, 238.0, 0, 0.431],
  [1597.6, 238.0, 1, 0.477],
  [1631.6, 238.0, 0, 0.479],
  [1666.0, 238.0, 1, 0.444],
  [1700.0, 238.0, 0, 0.393],
  [1734.0, 238.0, 0, 0.343],
  [1768.0, 238.0, 0, 0.302],
  [135.9, 272.0, 0, 0.447],
  [169.9, 272.0, 0, 0.453],
  [203.8, 272.0, 0, 0.457],
  [237.8, 272.0, 0, 0.46],
  [271.7, 272.0, 0, 0.463],
  [305.7, 272.0, 0, 0.468],
  [339.6, 272.0, 0, 0.474],
  [373.6, 272.0, 1, 0.476],
  [407.7, 272.0, 1, 0.47],
  [441.9, 272.0, 0, 0.448],
  [476.0, 272.0, 1, 0.403],
  [510.0, 272.0, 0, 0.339],
  [544.0, 272.0, 0, 0.274],
  [578.0, 272.0, 1, 0.23],
  [612.0, 272.0, 1, 0.22],
  [646.0, 272.0, 0, 0.235],
  [680.0, 272.0, 1, 0.284],
  [714.0, 272.0, 1, 0.357],
  [748.0, 272.0, 0, 0.428],
  [781.6, 272.0, 0, 0.474],
  [815.4, 272.0, 0, 0.49],
  [849.5, 272.0, 0, 0.484],
  [883.7, 272.0, 1, 0.465],
  [918.0, 272.0, 1, 0.444],
  [952.0, 272.0, 1, 0.424],
  [986.0, 272.0, 0, 0.408],
  [1020.0, 272.0, 0, 0.396],
  [1054.0, 272.0, 0, 0.386],
  [1088.0, 272.0, 0, 0.376],
  [1122.0, 272.0, 0, 0.367],
  [1156.0, 272.0, 0, 0.355],
  [1190.0, 272.0, 0, 0.339],
  [1224.0, 272.0, 0, 0.319],
  [1258.0, 272.0, 0, 0.294],
  [1292.0, 272.0, 0, 0.267],
  [1326.0, 272.0, 1, 0.243],
  [1360.0, 272.0, 0, 0.23],
  [1394.0, 272.0, 0, 0.231],
  [1428.0, 272.0, 0, 0.249],
  [1462.0, 272.0, 0, 0.297],
  [1496.0, 272.0, 0, 0.372],
  [1529.9, 272.0, 1, 0.449],
  [1563.4, 272.0, 1, 0.492],
  [1597.5, 272.0, 1, 0.485],
  [1632.0, 272.0, 1, 0.436],
  [1666.0, 272.0, 1, 0.371],
  [1700.0, 272.0, 0, 0.313],
  [1734.0, 272.0, 1, 0.273],
  [1768.0, 272.0, 0, 0.248],
  [135.2, 306.0, 0, 0.506],
  [169.2, 306.0, 0, 0.508],
  [203.2, 306.0, 0, 0.508],
  [237.2, 306.0, 0, 0.506],
  [271.2, 306.0, 0, 0.503],
  [305.3, 306.0, 0, 0.496],
  [339.5, 306.0, 0, 0.485],
  [373.7, 306.0, 0, 0.464],
  [408.0, 306.0, 0, 0.431],
  [442.0, 306.0, 0, 0.381],
  [476.0, 306.0, 1, 0.32],
  [510.0, 306.0, 1, 0.262],
  [544.0, 306.0, 0, 0.226],
  [578.0, 306.0, 0, 0.219],
  [612.0, 306.0, 1, 0.238],
  [646.0, 306.0, 1, 0.295],
  [680.0, 306.0, 1, 0.378],
  [713.9, 306.0, 0, 0.453],
  [747.4, 306.0, 1, 0.494],
  [781.3, 306.0, 0, 0.496],
  [815.7, 306.0, 0, 0.469],
  [850.0, 306.0, 0, 0.431],
  [884.0, 306.0, 0, 0.394],
  [918.0, 306.0, 1, 0.364],
  [952.0, 306.0, 0, 0.341],
  [986.0, 306.0, 1, 0.324],
  [1020.0, 306.0, 1, 0.311],
  [1054.0, 306.0, 1, 0.301],
  [1088.0, 306.0, 0, 0.292],
  [1122.0, 306.0, 0, 0.283],
  [1156.0, 306.0, 1, 0.273],
  [1190.0, 306.0, 0, 0.262],
  [1224.0, 306.0, 0, 0.248],
  [1258.0, 306.0, 0, 0.235],
  [1292.0, 306.0, 0, 0.226],
  [1326.0, 306.0, 1, 0.225],
  [1360.0, 306.0, 1, 0.232],
  [1394.0, 306.0, 0, 0.257],
  [1428.0, 306.0, 0, 0.311],
  [1462.0, 306.0, 1, 0.39],
  [1495.7, 306.0, 0, 0.466],
  [1529.2, 306.0, 1, 0.506],
  [1563.4, 306.0, 0, 0.49],
  [1598.0, 306.0, 0, 0.429],
  [1632.0, 306.0, 0, 0.354],
  [1666.0, 306.0, 1, 0.293],
  [1700.0, 306.0, 1, 0.257],
  [1734.0, 306.0, 0, 0.241],
  [1768.0, 306.0, 1, 0.234],
  [101.3, 340.0, 1, 0.499],
  [135.3, 340.0, 0, 0.497],
  [169.4, 340.0, 0, 0.494],
  [203.4, 340.0, 0, 0.49],
  [237.5, 340.0, 1, 0.483],
  [271.6, 340.0, 0, 0.472],
  [305.8, 340.0, 0, 0.454],
  [340.0, 340.0, 0, 0.428],
  [374.0, 340.0, 0, 0.392],
  [408.0, 340.0, 0, 0.345],
  [442.0, 340.0, 0, 0.293],
  [476.0, 340.0, 0, 0.247],
  [510.0, 340.0, 1, 0.221],
  [544.0, 340.0, 1, 0.219],
  [578.0, 340.0, 1, 0.243],
  [612.0, 340.0, 0, 0.307],
  [646.0, 340.0, 0, 0.396],
  [679.6, 340.0, 1, 0.474],
  [713.2, 340.0, 1, 0.509],
  [747.4, 340.0, 0, 0.494],
  [781.9, 340.0, 0, 0.448],
  [816.0, 340.0, 1, 0.393],
  [850.0, 340.0, 0, 0.345],
  [884.0, 340.0, 0, 0.31],
  [918.0, 340.0, 0, 0.287],
  [952.0, 340.0, 0, 0.271],
  [986.0, 340.0, 0, 0.26],
  [1020.0, 340.0, 1, 0.251],
  [1054.0, 340.0, 1, 0.243],
  [1088.0, 340.0, 0, 0.237],
  [1122.0, 340.0, 0, 0.231],
  [1156.0, 340.0, 0, 0.225],
  [1190.0, 340.0, 0, 0.221],
  [1224.0, 340.0, 1, 0.219],
  [1258.0, 340.0, 1, 0.22],
  [1292.0, 340.0, 0, 0.225],
  [1326.0, 340.0, 1, 0.24],
  [1360.0, 340.0, 0, 0.275],
  [1394.0, 340.0, 0, 0.335],
  [1428.0, 340.0, 0, 0.413],
  [1461.5, 340.0, 0, 0.486],
  [1495.0, 340.0, 0, 0.52],
  [1529.4, 340.0, 1, 0.495],
  [1564.0, 340.0, 1, 0.425],
  [1598.0, 340.0, 0, 0.342],
  [1632.0, 340.0, 0, 0.28],
  [1666.0, 340.0, 0, 0.25],
  [1700.0, 340.0, 0, 0.242],
  [1734.0, 340.0, 0, 0.243],
  [1768.0, 340.0, 0, 0.254],
  [1802.0, 340.0, 0, 0.27],
  [1836.0, 340.0, 0, 0.285],
  [102.0, 374.0, 0, 0.43],
  [136.0, 374.0, 1, 0.423],
  [170.0, 374.0, 1, 0.418],
  [204.0, 374.0, 0, 0.411],
  [238.0, 374.0, 1, 0.401],
  [272.0, 374.0, 0, 0.386],
  [306.0, 374.0, 1, 0.364],
  [340.0, 374.0, 0, 0.334],
  [374.0, 374.0, 1, 0.298],
  [408.0, 374.0, 1, 0.262],
  [442.0, 374.0, 1, 0.232],
  [476.0, 374.0, 0, 0.218],
  [510.0, 374.0, 0, 0.221],
  [544.0, 374.0, 0, 0.252],
  [578.0, 374.0, 0, 0.321],
  [612.0, 374.0, 1, 0.414],
  [645.4, 374.0, 1, 0.492],
  [679.0, 374.0, 1, 0.52],
  [713.4, 374.0, 1, 0.492],
  [748.0, 374.0, 0, 0.428],
  [782.0, 374.0, 1, 0.36],
  [816.0, 374.0, 0, 0.308],
  [850.0, 374.0, 1, 0.276],
  [884.0, 374.0, 0, 0.26],
  [918.0, 374.0, 0, 0.252],
  [952.0, 374.0, 0, 0.246],
  [986.0, 374.0, 0, 0.24],
  [1020.0, 374.0, 0, 0.235],
  [1054.0, 374.0, 1, 0.229],
  [1088.0, 374.0, 1, 0.225],
  [1122.0, 374.0, 1, 0.221],
  [1156.0, 374.0, 0, 0.22],
  [1190.0, 374.0, 0, 0.221],
  [1224.0, 374.0, 0, 0.227],
  [1258.0, 374.0, 1, 0.239],
  [1292.0, 374.0, 0, 0.265],
  [1326.0, 374.0, 0, 0.308],
  [1360.0, 374.0, 0, 0.37],
  [1394.0, 374.0, 0, 0.444],
  [1427.2, 374.0, 0, 0.508],
  [1460.9, 374.0, 1, 0.532],
  [1495.3, 374.0, 1, 0.5],
  [1530.0, 374.0, 0, 0.421],
  [1564.0, 374.0, 1, 0.333],
  [1598.0, 374.0, 1, 0.272],
  [1632.0, 374.0, 0, 0.249],
  [1666.0, 374.0, 0, 0.246],
  [1700.0, 374.0, 0, 0.262],
  [1734.0, 374.0, 0, 0.293],
  [1768.0, 374.0, 1, 0.329],
  [1836.0, 374.0, 1, 0.384],
  [68.0, 408.0, 1, 0.346],
  [102.0, 408.0, 0, 0.336],
  [136.0, 408.0, 1, 0.329],
  [170.0, 408.0, 0, 0.322],
  [204.0, 408.0, 0, 0.315],
  [238.0, 408.0, 0, 0.306],
  [272.0, 408.0, 0, 0.292],
  [306.0, 408.0, 1, 0.275],
  [340.0, 408.0, 0, 0.255],
  [374.0, 408.0, 0, 0.235],
  [408.0, 408.0, 0, 0.222],
  [442.0, 408.0, 0, 0.218],
  [476.0, 408.0, 0, 0.228],
  [510.0, 408.0, 0, 0.267],
  [544.0, 408.0, 0, 0.341],
  [578.0, 408.0, 0, 0.435],
  [611.2, 408.0, 0, 0.51],
  [644.9, 408.0, 0, 0.531],
  [679.4, 408.0, 0, 0.489],
  [714.0, 408.0, 0, 0.412],
  [748.0, 408.0, 1, 0.335],
  [782.0, 408.0, 1, 0.284],
  [816.0, 408.0, 0, 0.261],
  [850.0, 408.0, 0, 0.254],
  [884.0, 408.0, 0, 0.253],
  [918.0, 408.0, 1, 0.254],
  [952.0, 408.0, 1, 0.257],
  [986.0, 408.0, 0, 0.258],
  [1020.0, 408.0, 0, 0.257],
  [1054.0, 408.0, 0, 0.254],
  [1088.0, 408.0, 1, 0.253],
  [1122.0, 408.0, 0, 0.253],
  [1156.0, 408.0, 0, 0.257],
  [1190.0, 408.0, 0, 0.267],
  [1224.0, 408.0, 0, 0.286],
  [1258.0, 408.0, 0, 0.316],
  [1292.0, 408.0, 1, 0.361],
  [1326.0, 408.0, 0, 0.419],
  [1359.5, 408.0, 1, 0.482],
  [1392.9, 408.0, 0, 0.531],
  [1426.7, 408.0, 0, 0.542],
  [1461.3, 408.0, 0, 0.501],
  [1496.0, 408.0, 1, 0.417],
  [1530.0, 408.0, 0, 0.327],
  [1564.0, 408.0, 1, 0.268],
  [1598.0, 408.0, 0, 0.25],
  [1632.0, 408.0, 1, 0.255],
  [1666.0, 408.0, 0, 0.288],
  [1700.0, 408.0, 0, 0.34],
  [1734.0, 408.0, 0, 0.394],
  [1768.0, 408.0, 0, 0.436],
  [1801.7, 408.0, 0, 0.465],
  [136.0, 442.0, 0, 0.265],
  [170.0, 442.0, 0, 0.261],
  [204.0, 442.0, 0, 0.255],
  [238.0, 442.0, 0, 0.248],
  [272.0, 442.0, 0, 0.24],
  [306.0, 442.0, 0, 0.232],
  [340.0, 442.0, 0, 0.225],
  [374.0, 442.0, 1, 0.221],
  [408.0, 442.0, 1, 0.224],
  [442.0, 442.0, 0, 0.245],
  [476.0, 442.0, 0, 0.293],
  [510.0, 442.0, 1, 0.37],
  [543.8, 442.0, 0, 0.46],
  [576.9, 442.0, 0, 0.528],
  [610.8, 442.0, 0, 0.54],
  [645.4, 442.0, 0, 0.488],
  [680.0, 442.0, 1, 0.399],
  [714.0, 442.0, 0, 0.317],
  [748.0, 442.0, 0, 0.269],
  [782.0, 442.0, 0, 0.256],
  [816.0, 442.0, 0, 0.257],
  [850.0, 442.0, 0, 0.269],
  [884.0, 442.0, 0, 0.289],
  [918.0, 442.0, 0, 0.309],
  [952.0, 442.0, 0, 0.325],
  [986.0, 442.0, 0, 0.334],
  [1020.0, 442.0, 0, 0.339],
  [1054.0, 442.0, 1, 0.34],
  [1088.0, 442.0, 0, 0.341],
  [1122.0, 442.0, 0, 0.345],
  [1156.0, 442.0, 0, 0.354],
  [1190.0, 442.0, 0, 0.37],
  [1224.0, 442.0, 0, 0.397],
  [1258.0, 442.0, 1, 0.434],
  [1291.6, 442.0, 0, 0.479],
  [1325.0, 442.0, 0, 0.524],
  [1358.6, 442.0, 0, 0.553],
  [1392.7, 442.0, 0, 0.547],
  [1427.4, 442.0, 0, 0.495],
  [1462.0, 442.0, 0, 0.409],
  [1496.0, 442.0, 1, 0.32],
  [1530.0, 442.0, 0, 0.265],
  [1564.0, 442.0, 0, 0.251],
  [1598.0, 442.0, 0, 0.265],
  [1632.0, 442.0, 1, 0.315],
  [1666.0, 442.0, 0, 0.386],
  [1699.9, 442.0, 0, 0.452],
  [1733.3, 442.0, 1, 0.498],
  [1767.0, 442.0, 1, 0.521],
  [1869.0, 442.0, 1, 0.523],
  [68.0, 476.0, 1, 0.255],
  [136.0, 476.0, 0, 0.252],
  [170.0, 476.0, 0, 0.249],
  [204.0, 476.0, 0, 0.244],
  [238.0, 476.0, 0, 0.239],
  [272.0, 476.0, 0, 0.235],
  [306.0, 476.0, 0, 0.233],
  [340.0, 476.0, 0, 0.236],
  [374.0, 476.0, 1, 0.25],
  [408.0, 476.0, 0, 0.281],
  [442.0, 476.0, 0, 0.335],
  [476.0, 476.0, 0, 0.41],
  [509.4, 476.0, 1, 0.491],
  [542.7, 476.0, 0, 0.547],
  [576.7, 476.0, 0, 0.547],
  [611.5, 476.0, 1, 0.486],
  [646.0, 476.0, 1, 0.389],
  [680.0, 476.0, 0, 0.305],
  [714.0, 476.0, 1, 0.261],
  [748.0, 476.0, 0, 0.255],
  [782.0, 476.0, 0, 0.268],
  [816.0, 476.0, 0, 0.301],
  [850.0, 476.0, 0, 0.345],
  [884.0, 476.0, 0, 0.386],
  [918.0, 476.0, 1, 0.418],
  [952.0, 476.0, 0, 0.439],
  [985.9, 476.0, 0, 0.451],
  [1019.8, 476.0, 1, 0.457],
  [1053.8, 476.0, 0, 0.459],
  [1087.8, 476.0, 0, 0.461],
  [1121.7, 476.0, 0, 0.465],
  [1155.6, 476.0, 0, 0.475],
  [1189.4, 476.0, 0, 0.49],
  [1223.1, 476.0, 0, 0.512],
  [1256.8, 476.0, 0, 0.537],
  [1290.5, 476.0, 0, 0.558],
  [1324.5, 476.0, 0, 0.564],
  [1358.8, 476.0, 0, 0.54],
  [1393.5, 476.0, 1, 0.48],
  [1428.0, 476.0, 0, 0.394],
  [1462.0, 476.0, 0, 0.311],
  [1496.0, 476.0, 0, 0.262],
  [1530.0, 476.0, 0, 0.253],
  [1564.0, 476.0, 0, 0.275],
  [1598.0, 476.0, 0, 0.34],
  [1632.0, 476.0, 1, 0.427],
  [1665.3, 476.0, 1, 0.5],
  [1698.8, 476.0, 1, 0.54],
  [1732.7, 476.0, 0, 0.546],
  [1766.9, 476.0, 0, 0.53],
  [1801.2, 476.0, 0, 0.506],
  [1835.5, 476.0, 1, 0.484],
  [68.0, 510.0, 0, 0.277],
  [102.0, 510.0, 0, 0.282],
  [136.0, 510.0, 0, 0.283],
  [170.0, 510.0, 0, 0.282],
  [204.0, 510.0, 0, 0.279],
  [238.0, 510.0, 0, 0.278],
  [272.0, 510.0, 0, 0.28],
  [306.0, 510.0, 1, 0.29],
  [340.0, 510.0, 0, 0.31],
  [374.0, 510.0, 0, 0.345],
  [408.0, 510.0, 1, 0.397],
  [441.8, 510.0, 0, 0.463],
  [474.9, 510.0, 1, 0.527],
  [508.4, 510.0, 0, 0.565],
  [542.6, 510.0, 0, 0.551],
  [577.5, 510.0, 0, 0.481],
  [612.0, 510.0, 1, 0.38],
  [646.0, 510.0, 0, 0.295],
  [680.0, 510.0, 0, 0.257],
  [714.0, 510.0, 1, 0.256],
  [748.0, 510.0, 1, 0.283],
  [782.0, 510.0, 0, 0.34],
  [816.0, 510.0, 1, 0.407],
  [849.7, 510.0, 0, 0.466],
  [883.2, 510.0, 1, 0.508],
  [916.9, 510.0, 1, 0.533],
  [950.7, 510.0, 1, 0.544],
  [984.7, 510.0, 0, 0.548],
  [1018.6, 510.0, 0, 0.549],
  [1052.7, 510.0, 0, 0.548],
  [1086.7, 510.0, 0, 0.549],
  [1120.6, 510.0, 0, 0.551],
  [1154.6, 510.0, 0, 0.556],
  [1188.5, 510.0, 1, 0.562],
  [1222.4, 510.0, 1, 0.568],
  [1256.4, 510.0, 0, 0.567],
  [1290.6, 510.0, 1, 0.552],
  [1325.1, 510.0, 0, 0.514],
  [1359.9, 510.0, 1, 0.451],
  [1394.0, 510.0, 1, 0.371],
  [1428.0, 510.0, 0, 0.299],
  [1462.0, 510.0, 1, 0.26],
  [1496.0, 510.0, 0, 0.255],
  [1530.0, 510.0, 1, 0.285],
  [1564.0, 510.0, 0, 0.363],
  [1597.8, 510.0, 0, 0.461],
  [1630.8, 510.0, 1, 0.538],
  [1664.4, 510.0, 1, 0.566],
  [1698.7, 510.0, 1, 0.549],
  [1733.2, 510.0, 0, 0.505],
  [1767.8, 510.0, 1, 0.455],
  [1802.0, 510.0, 1, 0.412],
  [102.0, 544.0, 0, 0.377],
  [136.0, 544.0, 0, 0.382],
  [170.0, 544.0, 0, 0.382],
  [204.0, 544.0, 0, 0.382],
  [238.0, 544.0, 0, 0.384],
  [272.0, 544.0, 0, 0.391],
  [306.0, 544.0, 1, 0.408],
  [340.0, 544.0, 0, 0.437],
  [373.6, 544.0, 1, 0.476],
  [407.0, 544.0, 0, 0.523],
  [440.5, 544.0, 0, 0.563],
  [474.3, 544.0, 0, 0.577],
  [508.7, 544.0, 0, 0.547],
  [543.7, 544.0, 0, 0.47],
  [578.0, 544.0, 0, 0.368],
  [612.0, 544.0, 1, 0.286],
  [646.0, 544.0, 1, 0.253],
  [680.0, 544.0, 0, 0.258],
  [714.0, 544.0, 0, 0.3],
  [748.0, 544.0, 0, 0.378],
  [781.7, 544.0, 0, 0.465],
  [814.9, 544.0, 0, 0.534],
  [848.3, 544.0, 1, 0.574],
  [882.1, 544.0, 0, 0.588],
  [916.1, 544.0, 0, 0.586],
  [950.3, 544.0, 0, 0.576],
  [984.4, 544.0, 0, 0.567],
  [1018.5, 544.0, 1, 0.559],
  [1052.6, 544.0, 0, 0.554],
  [1086.6, 544.0, 0, 0.552],
  [1120.6, 544.0, 0, 0.551],
  [1154.7, 544.0, 0, 0.549],
  [1188.7, 544.0, 1, 0.543],
  [1222.9, 544.0, 0, 0.53],
  [1257.2, 544.0, 0, 0.504],
  [1291.8, 544.0, 1, 0.463],
  [1326.0, 544.0, 0, 0.405],
  [1360.0, 544.0, 0, 0.339],
  [1394.0, 544.0, 0, 0.283],
  [1428.0, 544.0, 0, 0.257],
  [1462.0, 544.0, 0, 0.258],
  [1496.0, 544.0, 0, 0.297],
  [1530.0, 544.0, 1, 0.385],
  [1563.4, 544.0, 1, 0.491],
  [1596.4, 544.0, 0, 0.567],
  [1630.2, 544.0, 0, 0.582],
  [1664.8, 544.0, 0, 0.541],
  [1699.7, 544.0, 1, 0.469],
  [1734.0, 544.0, 0, 0.397],
  [67.3, 578.0, 0, 0.499],
  [101.2, 578.0, 1, 0.511],
  [135.1, 578.0, 0, 0.515],
  [169.1, 578.0, 0, 0.515],
  [203.1, 578.0, 0, 0.514],
  [237.1, 578.0, 1, 0.515],
  [271.0, 578.0, 0, 0.522],
  [304.8, 578.0, 0, 0.536],
  [338.6, 578.0, 1, 0.555],
  [372.3, 578.0, 0, 0.576],
  [406.1, 578.0, 1, 0.588],
  [440.3, 578.0, 0, 0.577],
  [474.9, 578.0, 0, 0.531],
  [509.9, 578.0, 0, 0.449],
  [544.0, 578.0, 0, 0.352],
  [578.0, 578.0, 0, 0.277],
  [612.0, 578.0, 0, 0.251],
  [646.0, 578.0, 0, 0.261],
  [680.0, 578.0, 1, 0.316],
  [714.0, 578.0, 1, 0.412],
  [747.1, 578.0, 1, 0.513],
  [780.2, 578.0, 0, 0.584],
  [813.8, 578.0, 1, 0.611],
  [847.9, 578.0, 0, 0.602],
  [882.3, 578.0, 1, 0.574],
  [916.8, 578.0, 0, 0.541],
  [951.1, 578.0, 1, 0.512],
  [985.4, 578.0, 1, 0.491],
  [1019.6, 578.0, 1, 0.477],
  [1053.7, 578.0, 0, 0.47],
  [1087.7, 578.0, 0, 0.466],
  [1121.8, 578.0, 0, 0.462],
  [1155.8, 578.0, 0, 0.456],
  [1190.0, 578.0, 0, 0.443],
  [1224.0, 578.0, 0, 0.421],
  [1258.0, 578.0, 0, 0.388],
  [1292.0, 578.0, 1, 0.346],
  [1326.0, 578.0, 0, 0.301],
  [1360.0, 578.0, 0, 0.267],
  [1394.0, 578.0, 0, 0.256],
  [1428.0, 578.0, 0, 0.263],
  [1462.0, 578.0, 1, 0.312],
  [1496.0, 578.0, 1, 0.407],
  [1529.1, 578.0, 0, 0.518],
  [1562.1, 578.0, 1, 0.591],
  [1596.1, 578.0, 0, 0.593],
  [1630.9, 578.0, 1, 0.529],
  [1666.0, 578.0, 1, 0.435],
  [1700.0, 578.0, 1, 0.346],
  [1734.0, 578.0, 1, 0.283],
  [1768.0, 578.0, 0, 0.247],
  [133.8, 612.0, 1, 0.611],
  [167.8, 612.0, 1, 0.608],
  [201.9, 612.0, 0, 0.604],
  [235.9, 612.0, 0, 0.601],
  [270.0, 612.0, 0, 0.6],
  [304.0, 612.0, 1, 0.599],
  [338.0, 612.0, 1, 0.596],
  [372.2, 612.0, 1, 0.583],
  [406.6, 612.0, 0, 0.552],
  [441.3, 612.0, 0, 0.495],
  [476.0, 612.0, 1, 0.415],
  [510.0, 612.0, 0, 0.329],
  [544.0, 612.0, 0, 0.267],
  [578.0, 612.0, 0, 0.249],
  [612.0, 612.0, 0, 0.264],
  [646.0, 612.0, 0, 0.331],
  [680.0, 612.0, 0, 0.442],
  [712.6, 612.0, 1, 0.552],
  [745.7, 612.0, 1, 0.619],
  [779.6, 612.0, 0, 0.627],
  [814.1, 612.0, 0, 0.589],
  [848.9, 612.0, 0, 0.531],
  [883.6, 612.0, 0, 0.471],
  [918.0, 612.0, 0, 0.422],
  [952.0, 612.0, 1, 0.386],
  [986.0, 612.0, 1, 0.363],
  [1020.0, 612.0, 1, 0.35],
  [1054.0, 612.0, 1, 0.344],
  [1088.0, 612.0, 0, 0.341],
  [1122.0, 612.0, 0, 0.339],
  [1156.0, 612.0, 0, 0.334],
  [1190.0, 612.0, 1, 0.324],
  [1224.0, 612.0, 1, 0.308],
  [1258.0, 612.0, 0, 0.287],
  [1292.0, 612.0, 0, 0.267],
  [1326.0, 612.0, 1, 0.256],
  [1360.0, 612.0, 0, 0.256],
  [1394.0, 612.0, 0, 0.274],
  [1428.0, 612.0, 1, 0.333],
  [1462.0, 612.0, 1, 0.434],
  [1494.7, 612.0, 1, 0.545],
  [1527.8, 612.0, 1, 0.613],
  [1561.9, 612.0, 0, 0.602],
  [1597.0, 612.0, 0, 0.52],
  [1632.0, 612.0, 0, 0.407],
  [1666.0, 612.0, 0, 0.309],
  [1700.0, 612.0, 0, 0.249],
  [1734.0, 612.0, 1, 0.223],
  [65.5, 646.0, 0, 0.633],
  [133.8, 646.0, 0, 0.611],
  [167.9, 646.0, 0, 0.602],
  [202.0, 646.0, 0, 0.594],
  [236.1, 646.0, 0, 0.586],
  [270.3, 646.0, 1, 0.575],
  [304.5, 646.0, 0, 0.559],
  [338.9, 646.0, 1, 0.533],
  [373.4, 646.0, 0, 0.494],
  [408.0, 646.0, 0, 0.437],
  [442.0, 646.0, 0, 0.367],
  [476.0, 646.0, 0, 0.299],
  [510.0, 646.0, 1, 0.255],
  [544.0, 646.0, 1, 0.247],
  [578.0, 646.0, 0, 0.269],
  [612.0, 646.0, 1, 0.346],
  [645.7, 646.0, 1, 0.467],
  [678.2, 646.0, 1, 0.583],
  [711.3, 646.0, 1, 0.643],
  [745.5, 646.0, 0, 0.631],
  [780.4, 646.0, 1, 0.564],
  [815.6, 646.0, 1, 0.477],
  [850.0, 646.0, 0, 0.398],
  [884.0, 646.0, 0, 0.337],
  [918.0, 646.0, 0, 0.296],
  [952.0, 646.0, 1, 0.27],
  [986.0, 646.0, 1, 0.256],
  [1020.0, 646.0, 1, 0.25],
  [1054.0, 646.0, 1, 0.248],
  [1088.0, 646.0, 1, 0.249],
  [1122.0, 646.0, 0, 0.25],
  [1156.0, 646.0, 0, 0.251],
  [1190.0, 646.0, 1, 0.251],
  [1224.0, 646.0, 1, 0.25],
  [1258.0, 646.0, 0, 0.25],
  [1292.0, 646.0, 0, 0.253],
  [1326.0, 646.0, 1, 0.263],
  [1360.0, 646.0, 0, 0.297],
  [1394.0, 646.0, 0, 0.366],
  [1427.7, 646.0, 0, 0.468],
  [1460.3, 646.0, 0, 0.573],
  [1493.5, 646.0, 0, 0.632],
  [1527.8, 646.0, 0, 0.61],
  [1563.1, 646.0, 0, 0.513],
  [1598.0, 646.0, 0, 0.387],
  [1632.0, 646.0, 1, 0.285],
  [1666.0, 646.0, 1, 0.231],
  [1700.0, 646.0, 0, 0.218],
  [1734.0, 646.0, 0, 0.222],
  [1768.0, 646.0, 0, 0.242],
  [101.0, 680.0, 0, 0.526],
  [135.2, 680.0, 1, 0.509],
  [169.3, 680.0, 0, 0.498],
  [203.4, 680.0, 0, 0.487],
  [237.6, 680.0, 0, 0.476],
  [271.8, 680.0, 0, 0.46],
  [306.0, 680.0, 0, 0.436],
  [340.0, 680.0, 0, 0.403],
  [374.0, 680.0, 0, 0.359],
  [408.0, 680.0, 1, 0.31],
  [442.0, 680.0, 0, 0.267],
  [476.0, 680.0, 0, 0.244],
  [510.0, 680.0, 0, 0.246],
  [544.0, 680.0, 1, 0.278],
  [578.0, 680.0, 1, 0.364],
  [611.4, 680.0, 1, 0.491],
  [643.8, 680.0, 1, 0.609],
  [677.1, 680.0, 0, 0.661],
  [711.5, 680.0, 1, 0.629],
  [746.8, 680.0, 0, 0.538],
  [782.0, 680.0, 0, 0.429],
  [816.0, 680.0, 1, 0.339],
  [850.0, 680.0, 0, 0.278],
  [884.0, 680.0, 0, 0.244],
  [918.0, 680.0, 1, 0.227],
  [952.0, 680.0, 0, 0.22],
  [986.0, 680.0, 0, 0.218],
  [1020.0, 680.0, 0, 0.219],
  [1054.0, 680.0, 0, 0.222],
  [1088.0, 680.0, 0, 0.226],
  [1122.0, 680.0, 0, 0.231],
  [1156.0, 680.0, 0, 0.237],
  [1190.0, 680.0, 0, 0.244],
  [1224.0, 680.0, 1, 0.252],
  [1258.0, 680.0, 0, 0.265],
  [1292.0, 680.0, 1, 0.291],
  [1326.0, 680.0, 0, 0.338],
  [1360.0, 680.0, 0, 0.414],
  [1393.1, 680.0, 1, 0.512],
  [1425.9, 680.0, 0, 0.605],
  [1459.2, 680.0, 0, 0.651],
  [1493.7, 680.0, 1, 0.616],
  [1529.2, 680.0, 1, 0.507],
  [1564.0, 680.0, 0, 0.372],
  [1598.0, 680.0, 0, 0.269],
  [1632.0, 680.0, 0, 0.224],
  [1666.0, 680.0, 1, 0.219],
  [1700.0, 680.0, 0, 0.239],
  [1734.0, 680.0, 0, 0.284],
  [102.0, 714.0, 1, 0.38],
  [136.0, 714.0, 0, 0.364],
  [170.0, 714.0, 1, 0.353],
  [204.0, 714.0, 0, 0.344],
  [238.0, 714.0, 1, 0.334],
  [272.0, 714.0, 1, 0.321],
  [306.0, 714.0, 0, 0.303],
  [340.0, 714.0, 0, 0.281],
  [374.0, 714.0, 0, 0.258],
  [408.0, 714.0, 0, 0.241],
  [442.0, 714.0, 0, 0.238],
  [476.0, 714.0, 0, 0.249],
  [510.0, 714.0, 0, 0.294],
  [544.0, 714.0, 1, 0.389],
  [577.1, 714.0, 0, 0.518],
  [609.5, 714.0, 0, 0.632],
  [642.9, 714.0, 0, 0.675],
  [677.6, 714.0, 0, 0.627],
  [713.1, 714.0, 0, 0.516],
  [748.0, 714.0, 1, 0.392],
  [782.0, 714.0, 1, 0.299],
  [816.0, 714.0, 0, 0.247],
  [850.0, 714.0, 1, 0.227],
  [884.0, 714.0, 0, 0.222],
  [918.0, 714.0, 1, 0.222],
  [952.0, 714.0, 0, 0.228],
  [986.0, 714.0, 0, 0.235],
  [1020.0, 714.0, 1, 0.242],
  [1054.0, 714.0, 0, 0.249],
  [1088.0, 714.0, 0, 0.256],
  [1122.0, 714.0, 0, 0.265],
  [1156.0, 714.0, 0, 0.277],
  [1190.0, 714.0, 0, 0.293],
  [1224.0, 714.0, 1, 0.317],
  [1258.0, 714.0, 1, 0.354],
  [1292.0, 714.0, 0, 0.409],
  [1325.5, 714.0, 1, 0.483],
  [1358.4, 714.0, 0, 0.568],
  [1391.4, 714.0, 0, 0.641],
  [1425.0, 714.0, 1, 0.666],
  [1459.7, 714.0, 0, 0.617],
  [1495.3, 714.0, 0, 0.5],
  [1530.0, 714.0, 0, 0.361],
  [1564.0, 714.0, 0, 0.26],
  [1598.0, 714.0, 0, 0.221],
  [1632.0, 714.0, 1, 0.224],
  [1666.0, 714.0, 1, 0.265],
  [1700.0, 714.0, 0, 0.339],
  [1734.0, 714.0, 0, 0.423],
  [68.0, 748.0, 0, 0.281],
  [170.0, 748.0, 0, 0.247],
  [204.0, 748.0, 0, 0.242],
  [238.0, 748.0, 0, 0.238],
  [272.0, 748.0, 0, 0.234],
  [306.0, 748.0, 1, 0.23],
  [340.0, 748.0, 1, 0.228],
  [374.0, 748.0, 0, 0.231],
  [408.0, 748.0, 0, 0.239],
  [442.0, 748.0, 0, 0.264],
  [476.0, 748.0, 0, 0.323],
  [510.0, 748.0, 0, 0.424],
  [542.6, 748.0, 0, 0.549],
  [575.2, 748.0, 0, 0.655],
  [608.7, 748.0, 0, 0.687],
  [643.6, 748.0, 0, 0.625],
  [679.3, 748.0, 0, 0.499],
  [714.0, 748.0, 0, 0.366],
  [748.0, 748.0, 0, 0.276],
  [782.0, 748.0, 0, 0.236],
  [816.0, 748.0, 0, 0.228],
  [850.0, 748.0, 0, 0.235],
  [884.0, 748.0, 0, 0.256],
  [918.0, 748.0, 0, 0.283],
  [952.0, 748.0, 0, 0.309],
  [986.0, 748.0, 0, 0.33],
  [1020.0, 748.0, 0, 0.346],
  [1054.0, 748.0, 0, 0.358],
  [1088.0, 748.0, 0, 0.369],
  [1122.0, 748.0, 1, 0.382],
  [1156.0, 748.0, 0, 0.399],
  [1190.0, 748.0, 1, 0.424],
  [1223.8, 748.0, 1, 0.46],
  [1257.2, 748.0, 0, 0.508],
  [1290.4, 748.0, 0, 0.568],
  [1323.5, 748.0, 0, 0.63],
  [1356.9, 748.0, 0, 0.675],
  [1390.9, 748.0, 0, 0.675],
  [1425.8, 748.0, 0, 0.61],
  [1461.4, 748.0, 0, 0.488],
  [1496.0, 748.0, 0, 0.35],
  [1530.0, 748.0, 1, 0.253],
  [1564.0, 748.0, 0, 0.221],
  [1598.0, 748.0, 1, 0.231],
  [1632.0, 748.0, 0, 0.293],
  [1666.0, 748.0, 0, 0.393],
  [1699.3, 748.0, 0, 0.498],
  [1732.2, 748.0, 0, 0.58],
  [1765.5, 748.0, 0, 0.633],
  [68.0, 782.0, 0, 0.232],
  [170.0, 782.0, 1, 0.219],
  [204.0, 782.0, 0, 0.218],
  [238.0, 782.0, 1, 0.218],
  [272.0, 782.0, 1, 0.221],
  [306.0, 782.0, 0, 0.227],
  [340.0, 782.0, 1, 0.238],
  [374.0, 782.0, 1, 0.26],
  [408.0, 782.0, 0, 0.301],
  [442.0, 782.0, 1, 0.372],
  [475.6, 782.0, 1, 0.473],
  [508.1, 782.0, 0, 0.588],
  [540.8, 782.0, 0, 0.678],
  [574.6, 782.0, 1, 0.696],
  [609.6, 782.0, 0, 0.622],
  [645.5, 782.0, 1, 0.485],
  [680.0, 782.0, 1, 0.349],
  [714.0, 782.0, 1, 0.263],
  [748.0, 782.0, 0, 0.235],
  [782.0, 782.0, 0, 0.236],
  [816.0, 782.0, 0, 0.267],
  [850.0, 782.0, 1, 0.319],
  [884.0, 782.0, 1, 0.375],
  [918.0, 782.0, 0, 0.425],
  [951.8, 782.0, 0, 0.463],
  [985.4, 782.0, 0, 0.49],
  [1019.2, 782.0, 0, 0.509],
  [1053.0, 782.0, 0, 0.523],
  [1086.8, 782.0, 0, 0.535],
  [1120.7, 782.0, 1, 0.548],
  [1154.4, 782.0, 0, 0.566],
  [1188.1, 782.0, 1, 0.589],
  [1221.7, 782.0, 1, 0.62],
  [1255.2, 782.0, 0, 0.655],
  [1288.7, 782.0, 0, 0.685],
  [1322.6, 782.0, 1, 0.697],
  [1357.0, 782.0, 0, 0.669],
  [1392.1, 782.0, 1, 0.59],
  [1427.7, 782.0, 0, 0.467],
  [1462.0, 782.0, 0, 0.337],
  [1496.0, 782.0, 1, 0.248],
  [1530.0, 782.0, 0, 0.222],
  [1564.0, 782.0, 0, 0.24],
  [1598.0, 782.0, 0, 0.319],
  [1632.0, 782.0, 0, 0.44],
  [1664.5, 782.0, 1, 0.557],
  [1697.4, 782.0, 0, 0.637],
  [1730.9, 782.0, 0, 0.671],
  [1764.9, 782.0, 1, 0.673],
  [1833.4, 782.0, 0, 0.638],
  [1867.7, 782.0, 0, 0.622],
  [68.0, 816.0, 0, 0.244],
  [102.0, 816.0, 0, 0.246],
  [136.0, 816.0, 0, 0.247],
  [170.0, 816.0, 0, 0.249],
  [204.0, 816.0, 0, 0.252],
  [238.0, 816.0, 0, 0.258],
  [272.0, 816.0, 0, 0.27],
  [306.0, 816.0, 0, 0.29],
  [340.0, 816.0, 0, 0.323],
  [374.0, 816.0, 1, 0.374],
  [407.9, 816.0, 1, 0.447],
  [440.8, 816.0, 0, 0.539],
  [473.5, 816.0, 1, 0.635],
  [506.5, 816.0, 1, 0.701],
  [540.5, 816.0, 1, 0.699],
  [575.8, 816.0, 1, 0.614],
  [611.6, 816.0, 1, 0.473],
  [646.0, 816.0, 0, 0.336],
  [680.0, 816.0, 1, 0.256],
  [714.0, 816.0, 0, 0.237],
  [748.0, 816.0, 1, 0.252],
  [782.0, 816.0, 0, 0.31],
  [816.0, 816.0, 0, 0.393],
  [849.6, 816.0, 0, 0.475],
  [882.8, 816.0, 0, 0.541],
  [916.1, 816.0, 0, 0.588],
  [949.7, 816.0, 1, 0.618],
  [983.4, 816.0, 0, 0.638],
  [1017.2, 816.0, 0, 0.652],
  [1051.1, 816.0, 0, 0.662],
  [1084.9, 816.0, 0, 0.671],
  [1118.8, 816.0, 0, 0.68],
  [1152.7, 816.0, 0, 0.69],
  [1186.5, 816.0, 0, 0.701],
  [1220.4, 816.0, 0, 0.709],
  [1254.4, 816.0, 1, 0.709],
  [1288.7, 816.0, 0, 0.69],
  [1323.4, 816.0, 0, 0.64],
  [1358.6, 816.0, 0, 0.552],
  [1394.0, 816.0, 0, 0.434],
  [1428.0, 816.0, 0, 0.318],
  [1462.0, 816.0, 0, 0.243],
  [1496.0, 816.0, 1, 0.224],
  [1530.0, 816.0, 0, 0.249],
  [1564.0, 816.0, 0, 0.343],
  [1597.6, 816.0, 0, 0.478],
  [1629.9, 816.0, 0, 0.601],
  [1663.0, 816.0, 0, 0.669],
  [1696.9, 816.0, 1, 0.676],
  [1731.4, 816.0, 0, 0.642],
  [1766.1, 816.0, 0, 0.591],
  [1800.7, 816.0, 0, 0.542],
  [1835.2, 816.0, 1, 0.504],
  [102.0, 850.0, 0, 0.352],
  [136.0, 850.0, 0, 0.361],
  [170.0, 850.0, 0, 0.367],
  [204.0, 850.0, 0, 0.374],
  [238.0, 850.0, 1, 0.386],
  [272.0, 850.0, 0, 0.406],
  [306.0, 850.0, 1, 0.438],
  [339.5, 850.0, 0, 0.484],
  [372.7, 850.0, 1, 0.546],
  [405.7, 850.0, 1, 0.617],
  [438.8, 850.0, 0, 0.683],
  [472.2, 850.0, 0, 0.718],
  [506.6, 850.0, 0, 0.694],
  [542.0, 850.0, 0, 0.599],
  [577.8, 850.0, 0, 0.457],
  [612.0, 850.0, 1, 0.325],
  [646.0, 850.0, 0, 0.253],
  [680.0, 850.0, 1, 0.24],
  [714.0, 850.0, 0, 0.27],
  [748.0, 850.0, 0, 0.354],
  [781.8, 850.0, 1, 0.463],
  [814.5, 850.0, 0, 0.561],
  [847.5, 850.0, 0, 0.629],
  [881.0, 850.0, 0, 0.666],
  [914.8, 850.0, 0, 0.682],
  [948.7, 850.0, 0, 0.688],
  [982.6, 850.0, 0, 0.69],
  [1016.6, 850.0, 0, 0.692],
  [1050.6, 850.0, 1, 0.696],
  [1084.5, 850.0, 0, 0.699],
  [1118.5, 850.0, 0, 0.702],
  [1152.5, 850.0, 0, 0.7],
  [1186.6, 850.0, 0, 0.692],
  [1220.9, 850.0, 1, 0.673],
  [1255.4, 850.0, 1, 0.637],
  [1290.3, 850.0, 0, 0.576],
  [1325.4, 850.0, 0, 0.491],
  [1360.0, 850.0, 0, 0.389],
  [1394.0, 850.0, 0, 0.294],
  [1428.0, 850.0, 0, 0.238],
  [1462.0, 850.0, 0, 0.226],
  [1496.0, 850.0, 1, 0.26],
  [1530.0, 850.0, 0, 0.364],
  [1563.2, 850.0, 1, 0.509],
  [1595.5, 850.0, 0, 0.632],
  [1628.7, 850.0, 0, 0.685],
  [1663.1, 850.0, 0, 0.663],
  [1698.1, 850.0, 0, 0.592],
  [1733.2, 850.0, 1, 0.509],
  [1768.0, 850.0, 0, 0.438],
  [1802.0, 850.0, 1, 0.387],
  [1836.0, 850.0, 0, 0.354],
  [1904.0, 850.0, 0, 0.322],
  [101.0, 884.0, 1, 0.52],
  [134.9, 884.0, 0, 0.531],
  [168.8, 884.0, 0, 0.539],
  [202.7, 884.0, 1, 0.548],
  [236.5, 884.0, 0, 0.561],
  [270.2, 884.0, 1, 0.582],
  [303.8, 884.0, 0, 0.611],
  [337.3, 884.0, 1, 0.649],
  [370.7, 884.0, 0, 0.689],
  [404.2, 884.0, 0, 0.719],
  [438.2, 884.0, 0, 0.721],
  [472.9, 884.0, 0, 0.673],
  [508.3, 884.0, 0, 0.571],
  [544.0, 884.0, 0, 0.435],
  [578.0, 884.0, 0, 0.314],
  [612.0, 884.0, 1, 0.251],
  [646.0, 884.0, 1, 0.243],
  [680.0, 884.0, 0, 0.288],
  [714.0, 884.0, 0, 0.393],
  [747.0, 884.0, 0, 0.521],
  [779.6, 884.0, 1, 0.624],
  [812.8, 884.0, 1, 0.679],
  [846.6, 884.0, 1, 0.69],
  [880.9, 884.0, 0, 0.675],
  [915.2, 884.0, 0, 0.651],
  [949.5, 884.0, 0, 0.629],
  [983.8, 884.0, 0, 0.614],
  [1017.9, 884.0, 0, 0.606],
  [1051.9, 884.0, 1, 0.604],
  [1085.9, 884.0, 0, 0.603],
  [1120.0, 884.0, 0, 0.599],
  [1154.1, 884.0, 0, 0.589],
  [1188.4, 884.0, 0, 0.568],
  [1222.9, 884.0, 0, 0.532],
  [1257.6, 884.0, 0, 0.479],
  [1292.0, 884.0, 1, 0.41],
  [1326.0, 884.0, 0, 0.334],
  [1360.0, 884.0, 0, 0.269],
  [1394.0, 884.0, 0, 0.234],
  [1428.0, 884.0, 0, 0.231],
  [1462.0, 884.0, 0, 0.274],
  [1496.0, 884.0, 0, 0.386],
  [1528.8, 884.0, 0, 0.535],
  [1561.2, 884.0, 0, 0.655],
  [1594.6, 884.0, 0, 0.693],
  [1629.4, 884.0, 1, 0.643],
  [1664.8, 884.0, 0, 0.542],
  [1700.0, 884.0, 0, 0.436],
  [1734.0, 884.0, 0, 0.354],
  [1768.0, 884.0, 0, 0.303],
  [1802.0, 884.0, 0, 0.277],
  [1836.0, 884.0, 0, 0.266],
  [65.2, 918.0, 0, 0.653],
  [132.9, 918.0, 0, 0.671],
  [166.9, 918.0, 0, 0.676],
  [200.8, 918.0, 1, 0.682],
  [234.6, 918.0, 0, 0.691],
  [268.5, 918.0, 1, 0.702],
  [302.3, 918.0, 0, 0.715],
  [336.1, 918.0, 0, 0.724],
  [370.2, 918.0, 1, 0.722],
  [404.6, 918.0, 0, 0.694],
  [439.5, 918.0, 0, 0.629],
  [474.9, 918.0, 1, 0.526],
  [510.0, 918.0, 1, 0.403],
  [544.0, 918.0, 1, 0.3],
  [578.0, 918.0, 1, 0.25],
  [612.0, 918.0, 0, 0.248],
  [646.0, 918.0, 0, 0.304],
  [680.0, 918.0, 0, 0.426],
  [712.4, 918.0, 0, 0.565],
  [745.0, 918.0, 0, 0.665],
  [778.5, 918.0, 0, 0.699],
  [812.9, 918.0, 0, 0.676],
  [847.6, 918.0, 0, 0.622],
  [882.5, 918.0, 0, 0.563],
  [917.1, 918.0, 1, 0.513],
  [951.6, 918.0, 0, 0.478],
  [985.8, 918.0, 1, 0.457],
  [1019.9, 918.0, 0, 0.446],
  [1054.0, 918.0, 1, 0.442],
  [1088.0, 918.0, 1, 0.44],
  [1122.0, 918.0, 1, 0.435],
  [1156.0, 918.0, 0, 0.423],
  [1190.0, 918.0, 0, 0.401],
  [1224.0, 918.0, 1, 0.368],
  [1258.0, 918.0, 0, 0.327],
  [1292.0, 918.0, 0, 0.283],
  [1326.0, 918.0, 0, 0.248],
  [1360.0, 918.0, 0, 0.234],
  [1394.0, 918.0, 0, 0.24],
  [1428.0, 918.0, 1, 0.296],
  [1462.0, 918.0, 1, 0.412],
  [1526.9, 918.0, 0, 0.672],
  [1560.6, 918.0, 0, 0.695],
  [1595.6, 918.0, 0, 0.623],
  [1631.3, 918.0, 0, 0.499],
  [1666.0, 918.0, 1, 0.379],
  [1700.0, 918.0, 0, 0.298],
  [1734.0, 918.0, 1, 0.26],
  [1768.0, 918.0, 1, 0.25],
  [98.5, 952.0, 0, 0.699],
  [132.5, 952.0, 0, 0.697],
  [200.5, 952.0, 0, 0.699],
  [234.5, 952.0, 0, 0.7],
  [268.5, 952.0, 0, 0.698],
  [302.7, 952.0, 1, 0.689],
  [371.6, 952.0, 0, 0.624],
  [441.8, 952.0, 1, 0.463],
  [476.0, 952.0, 0, 0.362],
  [544.0, 952.0, 0, 0.25],
  [578.0, 952.0, 0, 0.255],
  [612.0, 952.0, 1, 0.321],
  [645.9, 952.0, 0, 0.453],
  [710.6, 952.0, 0, 0.691],
  [779.3, 952.0, 1, 0.643],
  [814.6, 952.0, 0, 0.552],
  [849.7, 952.0, 0, 0.464],
  [952.0, 952.0, 0, 0.323],
  [986.0, 952.0, 0, 0.311],
  [1054.0, 952.0, 0, 0.305],
  [1088.0, 952.0, 0, 0.304],
  [1122.0, 952.0, 0, 0.302],
  [1156.0, 952.0, 1, 0.295],
  [1224.0, 952.0, 1, 0.267],
  [1258.0, 952.0, 1, 0.252],
  [1292.0, 952.0, 0, 0.242],
  [1326.0, 952.0, 0, 0.239],
  [1360.0, 952.0, 1, 0.261],
  [1394.0, 952.0, 0, 0.329],
  [1460.1, 952.0, 0, 0.587],
  [1492.7, 952.0, 0, 0.687],
  [1597.7, 952.0, 1, 0.465],
  [1632.0, 952.0, 0, 0.339],
  [1666.0, 952.0, 0, 0.265],
  [1734.0, 952.0, 0, 0.248],
  [1768.0, 952.0, 1, 0.264],
  [1836.0, 952.0, 1, 0.314],
  [99.9, 986.0, 0, 0.602],
  [134.0, 986.0, 0, 0.593],
  [168.1, 986.0, 0, 0.589],
  [202.1, 986.0, 0, 0.588],
  [304.6, 986.0, 0, 0.55],
  [339.1, 986.0, 1, 0.511],
  [373.8, 986.0, 1, 0.456],
  [476.0, 986.0, 0, 0.267],
  [578.0, 986.0, 0, 0.34],
  [611.6, 986.0, 0, 0.478],
  [710.6, 986.0, 0, 0.696],
  [745.9, 986.0, 0, 0.607],
  [918.0, 986.0, 0, 0.25],
  [1020.0, 986.0, 1, 0.25],
  [1054.0, 986.0, 1, 0.253],
  [1122.0, 986.0, 0, 0.256],
  [1156.0, 986.0, 0, 0.255],
  [1190.0, 986.0, 0, 0.252],
  [1224.0, 986.0, 1, 0.249],
  [1326.0, 986.0, 0, 0.303],
  [1458.5, 986.0, 0, 0.7],
  [1492.6, 986.0, 0, 0.693],
  [1632.0, 986.0, 0, 0.247],
  [1666.0, 986.0, 1, 0.24],
  [136.0, 1020.0, 0, 0.422],
  [170.0, 1020.0, 0, 0.418],
  [306.0, 1020.0, 0, 0.381],
  [544.0, 1020.0, 0, 0.366],
  [577.2, 1020.0, 0, 0.504],
  [642.2, 1020.0, 0, 0.718],
  [850.0, 1020.0, 0, 0.231],
  [1054.0, 1020.0, 0, 0.268],
  [1088.0, 1020.0, 0, 0.272],
  [1122.0, 1020.0, 0, 0.275],
  [1156.0, 1020.0, 0, 0.278],
  [1494.3, 1020.0, 0, 0.572],
  [1564.0, 1020.0, 1, 0.292],
  [238.0, 1054.0, 1, 0.283],
  [1020.0, 1054.0, 0, 0.359],
  [1088.0, 1054.0, 1, 0.375],
  [1156.0, 1054.0, 0, 0.391],
] as const;
